import React from 'react';
import { Check } from 'lucide-react';
export const BenefitsSection = () => {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const benefits = [{
    title: 'Hacer tu primer ritual esta semana',
    desc: 'Sin experiencia, sin comprar nada, con lo que tenés en casa.'
  }, {
    title: 'Dejar de sentir que lo hacés "mal"',
    desc: 'Cada paso está explicado con claridad. No hay forma de equivocarse.'
  }, {
    title: 'Construir un grimorio propio que realmente uses',
    desc: 'Con plantillas y estructura, no más cuadernos lindos abandonados.'
  }, {
    title: 'Conocer las hierbas que ya tenés y su poder',
    desc: 'Ruda, romero, laurel... las tenés en la cocina. Solo falta saber usarlas.'
  }, {
    title: 'Conectar con los ciclos lunares de TU cielo',
    desc: 'No el de Europa. El del hemisferio sur. Por fin.'
  }, {
    title: 'Practicar con calma y seguridad',
    desc: 'Porque tenés una guía clara y no necesitás improvisar.'
  }];
  return <section className="py-20 px-4 relative z-10" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <h2 className="font-cormorant text-4xl md:text-5xl text-center text-text-primary mb-12" data-id="element-20">
          Con este grimorio vas a poder...
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-21">
          {benefits.map((benefit, index) => <div key={index} className="flex gap-4 items-start bg-mystic-surface/50 p-6 rounded-lg border border-gold-dark/10" data-id="element-22">
              <div className="bg-gold-dark/20 p-1 rounded-full mt-1" data-id="element-23">
                <Check className="w-5 h-5 text-gold-light" data-id="element-24" />
              </div>
              <div data-id="element-25">
                <h3 className="text-lg text-text-primary font-medium mb-1" data-id="element-26">
                  {benefit.title}
                </h3>
                <p className="text-text-soft" data-id="element-27">{benefit.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-28">
          <button onClick={scrollToPricing} className="btn-gold px-10 py-4 rounded-full text-xl font-bold uppercase tracking-wide shadow-lg" data-id="element-29">
            SÍ, QUIERO EMPEZAR
          </button>
        </div>
      </div>
    </section>;
};